export default function formatDateMDY(date: Date) {
  const newDate = new Date(date);

  const day = newDate.toLocaleDateString('en-us', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
  });

  return `${day}`;
}
